import request from '@/utils/request'
import api from '../api'

export class OverseasReceipt {
  fcasettlebatch(data) {
    return request({
      url: api.overseasReceipt.fcasettlebatch,
      method: 'post',
      data
    })
  }
  orderDetails(data) {
    return request({
      url: api.overseasReceipt.orderDetails,
      method: 'post',
      data
    })
  }
  orderDetailsRetrieve(params) {
    return request({
      url: api.overseasReceipt.orderDetailsRetrieve,
      method: 'get',
      params
    })
  }
  refundList(data) {
    return request({
      url: api.overseasReceipt.refundList,
      method: 'post',
      data
    })
  }
  refund(data) {
    return request({
      url: api.overseasReceipt.refund,
      method: 'post',
      data
    })
  }
  dispute(data) {
    return request({
      url: api.overseasReceipt.dispute,
      method: 'post',
      data
    })
  }
  caseReplay(data) {
    return request({
      url: api.overseasReceipt.caseReplay,
      method: 'post',
      data
    })
  }
}
